import { formatAnalyticsSource } from '@/helpers/common';

type AnalyticsOrigin = {
  entryPoint: string;
};

export type StructuredAnalyticsSource<T extends Record<string, unknown> = {}> =
  T & {
    toolType: string;
    origin?: AnalyticsOrigin;
  };

export function resolveOriginEntryPoint(
  originEntryPoint?: string | null,
  fallbackToolType?: string | null
): string | undefined {
  const source = originEntryPoint || fallbackToolType;

  if (!source) {
    return undefined;
  }

  return formatAnalyticsSource(source);
}

export function buildStructuredAnalyticsSource<
  T extends Record<string, unknown> = {},
>(
  toolType?: string | null,
  originEntryPoint?: string | null,
  extra?: T
): StructuredAnalyticsSource<T> {
  const formattedToolType = formatAnalyticsSource(toolType ?? undefined);
  const formattedOriginEntryPoint = resolveOriginEntryPoint(
    originEntryPoint,
    formattedToolType
  );

  return {
    ...(extra ?? ({} as T)),
    toolType: formattedToolType,
    ...(formattedOriginEntryPoint
      ? { origin: { entryPoint: formattedOriginEntryPoint } }
      : {}),
  };
}
